(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('LaunchObjectTestManualController', LaunchObjectTestManualController);

    LaunchObjectTestManualController.$inject = ['$scope', '$state', 'ObjectTestResult', 'ParseLinks', 'AlertService', 'id', 'TabObjects', '$timeout', 'TestSettingTag', '$uibModal', '$filter'];

    function LaunchObjectTestManualController($scope, $state, ObjectTestResult, ParseLinks, AlertService, id, TabObjects, $timeout, TestSettingTag) {
        var vm = this;
        vm.tabObjects = [];
        vm.objectTestResults = [];
        vm.charToSearch = "";
        vm.page = 0;
        vm.filterTag = [];

        TestSettingTag.byDomain({size: 1000}, function (result) {
            vm.testsTag = result;
            vm.testsTag.forEach((tag)=>{
                tag.label = tag.testTag;
            })
        })

       /* vm.obj = id !== null && id !== undefined ? { id } : {};
        vm.objectTestResults = [];
        loadTest();*/

        if (id !== null && id !== undefined) {
            vm.obj ={};
            vm.obj.id = id;
            vm.objectTestResults = [];
            loadTest();
        }

        vm.reloadTest = function () {
            vm.objectTestResults = [];
            loadTest();
        }

        function loadTest() {
            vm.hasNotResults = false;
            TabObjects.get({id: vm.obj.id}).$promise.then(function (data) {
                vm.obj = data;
                vm.areChk = false;

                // all tags if none selected, otherwise use selected tags
                var tagList = vm.filterTag.length > 0 ? vm.filterTag : vm.testsTag;
                var tagIds = tagList.map(function(tag) {
                    return tag.id;
                });

                var promises = tagIds.map(function(tagId) {
                    return ObjectTestResult.byTags({
                        object: vm.obj.id,
                        testTagId: tagId,
                        isManual: true  // true
                    }).$promise;
                });

                Promise.all(promises).then(function (results) {
                    var tests = results.flat();
                    vm.objectTestResults = tests;
                    vm.objectTestResults.forEach(function (test) {
                        test.check = false;
                    });
                    vm.hasNotResults = tests.length === 0;
                });
            });
        }
        vm.applyTagsFilter = function ()  {
            loadTest()
        }

        vm.loadAll = function () {
            TabObjects.query({
                page: vm.page,
                size: 20,
                query: vm.charToSearch
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjects.push(data[i]);
                }
                vm.objNotSelected = id === null || id === undefined;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.tagListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "Select tags",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };

        vm.reset = function () {
            vm.page = 0;
            vm.tabActions = [];
            vm.loadAll();
        };

        vm.loadPage = function (page) {
            if (page < vm.links['last'] || page === vm.links['next']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.search = function (searchText) {
            vm.charToSearch = searchText;
            vm.page = 0;
            vm.tabObjects = [];
            vm.loadAll();
        };

        vm.selectObject = function (obj) {
            vm.hasNotResults = false;
            $state.transitionTo($state.$current, {
                id: obj.id
            }, {notify: true, location: "replace"});
        };

        vm.manualResult = function (object, result) {
            object.status = result ? 1  : -1;
            object.executionCount = 1 + object.executionCount;
            ObjectTestResult.update(object, function () {
                object.lastExecution = new Date();
            });
        }
    }
})();
